import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'companyGroup';

const companyGroupService = {
  getRows: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/rows`,
      data,
    });
  },

  updateCompanyGroup: (data) => {
    return request({
      method: Methods.PUT,
      resource: `${baseURL}`,
      data,
    });
  },

  createCompanyGroup: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },

  deleteCompanyGroup: (data, id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
      data,
    });
  },
};
export default companyGroupService;
